/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const connectionInfoLastTestOneLatencyMsOneMin = 0
export const connectionInfoLastTestOneLatencyMsOneMax = 9007199254740991

export const connectionInfoLastTestOneTestedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const connectionInfoUpdatedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const connectionInfoUpdatedByOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const ConnectionInfo = zod.object({
  apiKeyLast4: zod.string().nullable(),
  apiKeySet: zod.boolean(),
  baseUrl: zod.string().nullable(),
  lastTest: zod.union([
    zod.object({
      apiReady: zod.boolean(),
      authenticated: zod.boolean(),
      bookingEnabled: zod.boolean().nullable(),
      error: zod.union([
        zod.enum(['timeout', 'connection_refused', 'tls_error', 'unauthorized', 'bad_response', 'pf_not_ready']),
        zod.null(),
      ]),
      keeperVersion: zod.string().nullable(),
      latencyMs: zod.union([
        zod.int().min(connectionInfoLastTestOneLatencyMsOneMin).max(connectionInfoLastTestOneLatencyMsOneMax),
        zod.null(),
      ]),
      pfLoggedIn: zod.boolean(),
      pfTimeZone: zod.string().nullable(),
      reachable: zod.boolean(),
      testedAt: zod.iso.datetime({ offset: true }).regex(connectionInfoLastTestOneTestedAtRegExp),
      timeZoneMatches: zod.boolean().nullable(),
    }),
    zod.null(),
  ]),
  updatedAt: zod.union([zod.iso.datetime({ offset: true }).regex(connectionInfoUpdatedAtOneRegExp), zod.null()]),
  updatedBy: zod.union([
    zod.object({
      name: zod.string(),
      userId: zod.uuid().regex(connectionInfoUpdatedByOneUserIdRegExp),
    }),
    zod.null(),
  ]),
})

export type ConnectionInfo = zod.input<typeof ConnectionInfo>
export type ConnectionInfoOutput = zod.output<typeof ConnectionInfo>
